import { useEffect } from "react";
const HubSpotScript = _ref => {
  let {
    show
  } = _ref;
  useEffect(() => {
    if (show) {
      if (window.HubSpotConversations) {
        window.HubSpotConversations.widget.load();
      }
    } else {
      if (window.HubSpotConversations) {
        window.HubSpotConversations.widget.remove();
      }
    }
  }, [show]);
  useEffect(() => {
    const scriptId = "hs-script-loader";
    const existingScript = document.getElementById(scriptId);
    if (show) {
      if (!existingScript) {
        const script = document.createElement("script");
        script.src = "//js-na1.hs-scripts.com/".concat(process.env.NEXT_PUBLIC_HUBSPOT_ID, ".js");
        script.async = true;
        script.defer = true;
        script.id = scriptId;
        document.body.appendChild(script);
      }
    } else {
      const hubspotContainer = document.getElementById("hubspot-messages-iframe-container");
      if (hubspotContainer) {
        hubspotContainer.remove();
      }
      if (existingScript) {
        existingScript.remove();
      }
    }
  }, [show]);
  return null;
};
export default HubSpotScript;